import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-73658aa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "doc" }
const _hoisted_2 = { class: "doc-wrap" }
const _hoisted_3 = { class: "doc-head" }
const _hoisted_4 = { class: "doc-title" }
const _hoisted_5 = {
  key: 0,
  class: "doc-lede"
}
const _hoisted_6 = {
  key: 1,
  class: "doc-updated"
}
const _hoisted_7 = { class: "doc-body" }


export default /*#__PURE__*/_defineComponent({
  __name: 'DocPage',
  props: {
    title: {},
    lede: {},
    updated: {}
  },
  setup(__props: any) {

// defineProps is a compiler macro; this project's ESLint config predates it.
// eslint-disable-next-line no-undef


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.title), 1),
        (_ctx.lede)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.lede), 1))
          : _createCommentVNode("", true),
        (_ctx.updated)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.updated), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})